export class DqRemoteControlCommands {
  public static readonly accepted = 'accepted';
  public static readonly cancelled = 'cancelled';
  public static readonly declined = 'declined';
}

export interface DqRemoteControlMessage {
  chatId: string;
  command: DqRemoteControlCommands;
  rcHistoryId: string;
}
